import React from "react";
import Image from "next/image";
import { useQuery } from "react-query";
import axios from "axios";
import Link from "next/link";

const fetchTopUsers = async (modelId) => {
  try {
    const { data } = await axios.get(
      `/api/model/getTopUsers?modelId=${modelId}`,
    );
    return data.topUsers;
  } catch (error) {
    console.error(error);
    return [];
  }
};

const ModelTopUsersSection = ({ modelData }) => {
  const {
    data: topUsers,
    isLoading,
    error,
  } = useQuery(
    ["topUsers", modelData._id],
    () => fetchTopUsers(modelData._id),
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  );

  const getBorderColor = (index) => {
    if (index === 0) return "tw-border-yellow-400";
    if (index === 1) return "tw-border-slate-400";
    if (index === 2) return "tw-border-amber-700";
    return "tw-border-gray-500";
  };

  const getRankColor = (index) => {
    if (index === 0) return "tw-bg-yellow-400";
    if (index === 1) return "tw-bg-slate-400";
    if (index === 2) return "tw-bg-amber-700";
    return "tw-bg-gray-500";
  };

  const widths = [40, 16, 32];

  const SkeletonLoader = () => (
    <div className="tw-mt-2 tw-flex tw-flex-col tw-gap-2">
      {[...Array(3)].map((_, index) => (
        <div key={index} className="tw-flex tw-flex-col tw-mb-2">
          <div className="tw-flex tw-items-center">
            <div className="tw-w-11 tw-h-11 tw-rounded-full tw-bg-gray-200 tw-animate-pulse"></div>
            <div
              className={`tw-w-${widths[index]} tw-h-4 tw-bg-gray-200 tw-rounded-2xl tw-ml-2 tw-animate-pulse`}
            ></div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="tw-w-full">
      <div className="tw-font-bold tw-flex tw-text-xl">Top Users Today</div>
      <div className="tw-font-semibold tw-mt-1 tw-opacity-40 tw-text-sm">
        Users who have used this voice the most in the last 24 hours.
      </div>
      {isLoading ? (
        <SkeletonLoader />
      ) : (
        <div className="tw-mt-2 tw-flex tw-flex-col tw-gap-2 tw-bg-gray-100 tw-p-3 tw-w-full tw-rounded-2xl ">
          {topUsers && topUsers.length === 0 && (
            <div className="tw-text-center tw-p-8 tw-text-lg tw-font-bold tw-h-full tw-flex-col tw-items-center tw-justify-center">
              No users today...
              <div className="tw-text-xs tw-opacity-40 tw-font-semibold">
                Be the first!
              </div>
            </div>
          )}
          {topUsers &&
            topUsers.map((user, index) => (
              <Link
                key={user?.userId}
                href={`/@${user?.username}`}
                className="tw-flex tw-items-center tw-mb-2"
              >
                <Link
                  href={`/@${user?.username}`}
                  className={`tw-border-2 tw-relative tw-border-solid ${getBorderColor(index)} tw-flex tw-rounded-full tw-items-center tw-justify-center`}
                >
                  <Image
                    src={user?.avatar}
                    alt={user?.username}
                    width={40}
                    height={40}
                    className={`tw-rounded-full tw-p-0.5`}
                  />
                  <div className="tw-absolute tw--bottom-2 tw-p-0.5 tw-font-black tw-text-[10px] tw-text-white   tw-bg-white tw-rounded-full">
                    <div
                      className={`${getRankColor(index)} tw-px-1 tw-rounded-lg tw-flex tw-items-center tw-justify-center`}
                    >
                      {index + 1}
                    </div>
                  </div>
                </Link>
                <Link
                  href={`/@${user?.username}`}
                  className="tw-font-semibold tw-ml-2"
                >
                  {user?.username}
                </Link>
              </Link>
            ))}
        </div>
      )}
    </div>
  );
};

export default ModelTopUsersSection;
